<template>
	<SectionCard>
		<template #title>
			{{ 'Encryption Key' | useLabels }}
		</template>
		<template #title-action>
			<TextButton
				test-id="preference_page_create_encryption_key"
				@click="$emit('show-encryption-key-modal')"
			>
				Create new key
			</TextButton>
		</template>
		<template #subtitle>
			Select the encryption key that you will use to encrypt the specified fields, so that Syrenis is able to decrypt the information when the link is clicked on.
		</template>
		<template #body>
			<v-row dense>
				<v-col cols="6">
					<div class="d-flex align-center">
						<Dropdown
							label="Encryption Key *"
							test-id="preference_page_encryption_key"
							:value.sync="encryptionKeyId"
							:items="encryptionKeyItems"
							rules="required"
							show-item-chips
							@change="onChange('encryptionKeyId', $event)"
						/>
						<TextButton
							v-if="encryptionKeyId"
							@click="showTestDialog = true"
						>
							<v-icon>
								mdi-lock-open
							</v-icon>
							Test Decryption
						</TextButton>
					</div>
				</v-col>
			</v-row>
			<EncryptionTestDialog
				v-if="showTestDialog"
				:encryption-key-id="encryptionKeyId"
				:encryption-type-id="selectedEncryptionTypeId"
				@close="showTestDialog = false"
			/>
		</template>
	</SectionCard>
</template>

<script>
import SectionCard from '../../../../../../../shared/components/section-card.vue'
import Dropdown from '../../../../../../../shared/components/dropdown.vue'
import TextButton from '../../../../../../../shared/components/text-button.vue'
import EncryptionTestDialog from '../../../../shared/encryption/encryption-test-dialog.vue'
import { mapEncryptionKeysWithChips } from '../../../../../../../shared/utils/encryption-type-utils.js'

export default {
	components: {
		SectionCard,
		Dropdown,
		TextButton,
		EncryptionTestDialog
	},
	props: {
		encryptionKeyId: Number,
		encryptionKeys: Array,
		userFullPermissions: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			showTestDialog: false
		}
	},
	computed: {
		encryptionKeyItems () {
			return mapEncryptionKeysWithChips(this.encryptionKeys)
		},
		selectedEncryptionTypeId () {
			const selectedKey = this.encryptionKeys?.find(
				key => key.encryptionKeyId === this.encryptionKeyId
			)
			return selectedKey?.encryptionTypeId || 1
		}
	},
	methods: {
		onChange (key, value) {
			this.$emit('update:encryption-key', key, value)
		}
	}
}
</script>

<style scoped>
.encryption-key-card__add-key-button {
	margin-right: 12px;
}

.encryption-key-card__dropdown-row {
	margin-top: 8px;
}
</style>
